module.exports = __webpack_public_path__ + "9cd4f4eb7992d79d615176268462c68c.png";